import React, { useState, useEffect } from 'react';
import previousIcon from '../../assets/icons/previous-icon.svg';
import nextIcon from '../../assets/icons/next-icon.svg';
import './Slider.css';
import { Button } from '@material-ui/core';
import maximizeIcon from '../../assets/icons/maximize-icon.svg'

const Slider = ({ images, handleFullScreen }) => {
    const [currentImage, setCurrentImage] = useState(0);

    const handlePrevClick = () => {
        setCurrentImage(currentImage === 0 ? images.length - 1 : currentImage - 1);

        // const nextImage = currentImage === 0 ? images.length - 1 : currentImage - 1;

        // // Mevcut resmin görünürlüğünü kapat
        // const currentImg = document.querySelector(`.slider img:nth-child(${currentImage + 1})`);
        // currentImg.classList.add('hidden');

        // // Geçiş efektini uygula
        // const nextImg = document.querySelector(`.slider img:nth-child(${nextImage + 1})`);
        // nextImg.classList.remove('hidden');

        // // Resimleri güncelle
        // setCurrentImage(nextImage);
    };

    const handleNextClick = () => {
        setCurrentImage(currentImage === images.length - 1 ? 0 : currentImage + 1);
    };

    return (
        <div className='new-slider-container items-center-between'>
            {
                images && images.length > 0 &&
                <img className='direction-button m-l-16' onClick={handlePrevClick} src={previousIcon} />
            }
            <div className='new-slider-content'>
                {
                    images && images.length > 0 &&
                    <>
                        <img className='new-slider-image' src={images[currentImage].thumbnail} alt="Slider Image" />
                        <div className='slider-box-container'>
                            {
                                images?.map((_, i) => (
                                    <div onClick={() => setCurrentImage(i)} className={`slider-select-box ${currentImage === i ? 'active' : 'pasif'}`} key={i}></div>
                                ))
                            }
                        </div>
                    </>
                }
                {handleFullScreen && images && images.length > 0 && <Button onClick={() => handleFullScreen(images[currentImage].thumbnail)} className='slider-fullscreen-button' ><img alt="fullscreen" src={maximizeIcon} /></Button>}
            </div>
            {
                images && images.length > 0 &&
                <img className='direction-button m-r-16' onClick={handleNextClick} src={nextIcon} />
            }

        </div>
    );
};

export default Slider;